import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'

const firebaseConfig = {
    apiKey: "AIzaSyA391ZeEA0dSQS9V-slm9aXJAPCLjl3dBY",
    authDomain: "thedojosite-80d90.firebaseapp.com",
    projectId: "thedojosite-80d90",
    storageBucket: "thedojosite-80d90.appspot.com",
    messagingSenderId: "633156837105",
    appId: "1:633156837105:web:6ceea4e3472751c8515350"
  };


// init firebase

firebase.initializeApp(firebaseConfig)

// init services

const projectFirestore = firebase.firestore()

const projectAuth = firebase.auth()

const projectStorage = firebase.storage()

const timestamp = firebase.firestore.Timestamp

export {projectAuth, projectFirestore, projectStorage, timestamp}